/**
 * The state to store a path to redirect to when the user logs in.
 * @todo might be better to move to a pinia store?
 */
export default function () {
    return useState<string | undefined>()
}
